var _style, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHomeTrue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3600 3600",
    style: {
      enableBackground: "new 0 0 3600 3600"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E5E5E5;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1605.4,2020.2H1995v543.3h-389.6V2020.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1088.9,1557.8v1005.7h356.4v-703.3H2155v703.3h356V1557.8l-710.9-710.9L1088.9,1557.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1800.2,0c-356,0-703.9,105.6-999.8,303.4c-296,197.8-526.6,479-662.9,807.9S-34.3,1802.2,35.1,2151.4 c69.4,349.2,240.8,670,492.5,921.7c251.7,251.8,572.4,423.2,921.5,492.7c349.1,69.5,711,33.8,1039.8-102.4 c328.9-136.2,609.9-367,807.7-663S3600,2156.2,3600,1800.2c-0.3-315.9-83.7-626.2-241.7-899.7c-158-273.5-385.1-500.7-658.6-658.7 S2116.1,0.4,1800.2,0L1800.2,0z M2862.9,1909.8l-192-192v1005.7H929.2V1717.8l-191.6,192l-113.2-113.2L1800.2,620.5L2976,1796.6 L2862.9,1909.8z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeTrue);
export default __webpack_public_path__ + "static/media/home-true.743be06023d0c5ed58aa8c91b28b6a24.svg";
export { ForwardRef as ReactComponent };